export const LOCAL_STORAGE_KEYS = {
  appCache: "hs_app_cache",
};

export const COOKIE_KEYS = {
  nonce: "hs_woo_nonce",
  internalTraffic: "hs_internal_traffic",
};
